module.exports = __webpack_public_path__ + "static/media/cube.9ec60b97.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cube.svg
// module id = 1389
// module chunks = 0